import { PropsWithChildren } from 'react';
import { Box, Typography } from '@mui/material';
import {
  formSectionLastStyle,
  formSectionStyle,
} from '../../../helpers/styles/flashbook';

interface Props {
  title: string;
  hint?: string;
  isLast?: boolean;
}

export default function FormSection({
  title,
  hint,
  isLast,
  children,
}: PropsWithChildren<Props>) {
  return (
    <Box sx={isLast ? formSectionLastStyle : formSectionStyle}>
      <Typography variant="h4" mb={0.5}>
        {title}
      </Typography>
      {hint ? (
        <Typography variant="body2" color="text.secondary" mb={2}>
          {hint}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
